import { handleActions } from 'redux-actions';

const initialState = { isPassed: false };

export default handleActions({
  SET_PASSED() {
    return { isPassed: true };
  },
}, initialState);
